import * as React from 'react';
import { Route, Routes, useParams } from "react-router-dom"
import { Websites } from './Websites';
import { Form } from './Form';
import { Deploy } from './Deploy';
import { NotFound } from '../NotFound';
import { RoleSection } from '../../components/RoleSection';
import { NotAllowed } from '../NotAllowed';
import { AppSection } from '../../components/AppSection';
import { Website } from './Website';
import { PageForm } from './PageForm';

function FormRoute() {
    const params = useParams();
    return (<Form websiteKey={params.site!} />);
}

function PageRoute() {
    const params = useParams();
    return (<PageForm websiteKey={params.site!} collectionKey="page" pageKey={params.page!} />);
}

function WebsiteRoute() {
    const params = useParams();
    return (<Website websiteKey={params.site!} />);
}

function DeployRoute() {
    const params = useParams();
    return (<RoleSection role="admin" forbidden={<NotAllowed />} ><Deploy websiteKey={params.site!} /></RoleSection>);
}

export class PrimeLendingWebsites extends React.Component<any,any>{

    public render(){
        return (<React.Fragment>
        <AppSection section="websites/prime-lending" />
        <Routes>
            <Route path=":site/deploy" element={<DeployRoute />} />
            <Route path=":site/main-form" element={<FormRoute />} />
            <Route path=":site" element={<WebsiteRoute />} />
            <Route path=":site/pages/:page" element={<PageRoute />} />
            <Route path="" element={<Websites />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
        </React.Fragment>)
    }
}
